<template>
  <Row class-name="reservation" :style="minHeight">
    <Spin v-if="loading" fix></Spin>
    <Col>
      <BreadcrumbWrap />
      <p class="title">查档信息登记</p>
    </Col>
    <Col span="24">
      <Row type="flex" justify="center">
        <Col :xxl="14" :xl="18" :sm="22" :xs="24">
          <InfoRegister
            v-if="formItems.length"
            :formItems="formItems"
            :otherParams="{ CDType: type }"
            unitType="company"
          >
            <Button
              type="primary"
              @click="handGoBack"
            >返回</Button>
          </InfoRegister>
        </Col>
      </Row>
    </Col>
  </Row>
</template>

<script>
import InfoRegister from '@components/info-register'
import { editForm } from './formItems'
import BreadcrumbWrap from '@components/breadcrumb-wrap'
export default {
  name: 'reservation',
  components: { InfoRegister, BreadcrumbWrap },
  data () {
    return {
      formItems: [],
      item: {},
      type: '',
      loading: false
    }
  },
  computed: {
    minHeight () {
      return { 'min-height': `${this.$store.state.init.offsetHeight - 251}px` }
    }
  },
  watch: {
    async type () {
      await this.buildFormItems()
      this.setFormValue()
    }
  },
  activated () {
    this.type = this.$route.meta.type
    this.setFormValue()
  },
  methods: {
    async buildFormItems () {
      this.loading = true
      try {
        this.item.CDType = this.type
        const formItems = await editForm.call(this)
        this.$set(this, 'formItems', formItems)
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    },
    setFormValue () {
      const items = this.$route.params.item || []
      const engItem = []
      items.map(m => !engItem.some(s => s.ENG_SID === m.ENG_SID ) && engItem.push(m))
      this.formItems.map(m => {
        const { key } = m
        if (key === 'ArchiveIDS') {
          this.$set(m, 'value', engItem.map(m => m.ENG_SID).join(','))
          this.$set(m, 'options', engItem.map(m => ({
            value: m.ENG_SID,
            text: m.ENG_NAME
          })))
        } else if (key === 'QueryContent') {
          this.$set(m, 'value', items)
          this.$set(m, 'options', items.map(m => ({
            value: m.SID,
            text: m.FILE_TITLE
          })))
        }
      })
    },
    handGoBack () {
      this.$router.push({ name: 'search' })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@theme/globle.scss';
.reservation {
  background: #fff;
  padding: 16px;
  border-top: 2px solid $default;
}
.title {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  margin-top: 16px;
  margin-bottom: 4px;
}
</style>
